import i18next from "i18next";
import ar from "./navigation-i18n/ar";
import en from "./navigation-i18n/en";
import tr from "./navigation-i18n/tr";

i18next.addResourceBundle("en", "navigation", en);
i18next.addResourceBundle("tr", "navigation", tr);
i18next.addResourceBundle("ar", "navigation", ar);
import authRoles from "../auth/authRoles";
import jwtDecode from "jwt-decode";
import OAuthService from "../auth/services/oAuthService";

const getNavigation = () => {
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));

  let navigationConfig = [];

  if (token) {
    if (token.email == 'orders@noltefze.com' && (token.scope.includes("ROLE_ADMIN") || token.scope.includes("ROLE_MD") || token.scope.includes("ROLE_SOPDIR"))) {
      navigationConfig = [
        {
          id: "order.dashboard",
          title: "Dashboard",
          type: "item",
          // icon: 'material-twotone:speed',
          url: "/order/dashboard",
        },
        {
          id: "addministration",
          title: "Administration",
          type: "collapse",
          // icon: "heroicons-outline:presentation-chart-line",
          // translate: 'Administration',
          children: [
            {
              id: "customers-component",
              title: "Partners",
              translate: "Partners",
              type: "item",
              // icon: 'heroicons-outline:users',
              url: "partners",
            },
            {
              id: "factory-vendor",
              title: "Factory Vendor",
              // translate: 'FactoryVendor',
              type: "item",
              // icon: 'heroicons-outline:home',
              url: "factoryVendors",
            },
            {
              id: "material-master-component",
              title: "Material Master",
              // translate: 'OrderCategory',
              type: "item",
              // icon: 'heroicons-outline:credit-card',
              url: "materialMasters",
            },

          ],
        },
        {
          id: "discount",
          title: "Discount",
          type: "collapse",
          // icon: "feather:percent",
          translate: "Discount",
          children: [
            {
              id: "discount-master-component",
              title: "Discount Master",
              // translate: 'OrderCategory',
              type: "item",
              // icon: 'feather:percent',
              url: "discountMaster",
            },

          ],
        },
        {
          id: "reports",
          title: "Reports",
          type: "collapse",
          children: [
            {
              id: "ao-analysis",
              title: "AO Analysis ",
              type: "item",
              url: "/reports/ao-analysis",
            },
            {
              id: "report-dashboard",
              title: "Sales/Purchase Reports",
              type: "item",
              url: "/reports/reportDashboard"
            },
            {
              id: "factory-issues",
              title: "Factory Issues ",
              type: "item",
              url: "/reports/factory-issues",
            },

          ],
        },
        {
          id: "create.order",
          title: "Create Order",
          type: "item",
          // icon: 'heroicons-outline:plus',
          url: "/order/create-order",
        },
        {
          id: "part.order",
          title: "Part Order",
          type: "item",
          // icon: 'heroicons-outline:plus',
          url: "/order/create-part-order",
        },
        {
          id: "project.order",
          title: " Bulk Project Order",
          type: "item",
          // icon: 'heroicons-outline:plus',
          url: "/order/special-project-order",
        },
        {
          id: "bulk.part.order",
          title: "Bulk Part Order",
          type: "item",
          url: "/order/bulk-part-order",
        },
        {
          id: "new.order",
          title: "New Orders",
          type: "item",
          // icon: 'heroicons-outline:desktop-computer',
          url: "/order/new-order-list",
        },
        {
          id: "order.management",
          title: "Order Management",
          type: "item",
          // icon: 'heroicons-outline:desktop-computer',
          url: "/order/order-list",
        }, {
          id: "container.management",
          title: "Container Management",
          type: "item",
          // icon: 'heroicons-outline:truck',
          url: "/container-list",
        },
        {
          id: "special.discount",
          title: "Special Discount",
          type: "item",
          url: "/special-discount",
        },
      ];
    }
    else if (token.scope.includes("ROLE_FACTORY_QA")) {
      navigationConfig = [

        {
          id: "reports",
          title: "Reports",
          type: "collapse",
          children: [
            {
              id: "ao-analysis",
              title: "AO Analysis ",
              type: "item",
              url: "/reports/ao-analysis",
            },

            {
              id: "factory-issues",
              title: "Factory Issues ",
              type: "item",
              url: "/reports/factory-issues",
            },

          ],
        },

      ];


    }
    else if ((token.scope.includes("ROLE_ORDERPRO") || token.scope.includes("ROLE_EXTORDPROCESS")) && !(token.scope.includes("ROLE_ADMIN") || token.scope.includes("ROLE_MD") || token.scope.includes("ROLE_SOPDIR"))) {
      navigationConfig = [
        {
          id: "order.dashboard",
          title: "Dashboard",
          type: "item",
          // icon: 'material-twotone:speed',
          url: "/order/dashboard",
        },
        {
          id: "create.order",
          title: "Create Order",
          type: "item",
          // icon: 'heroicons-outline:plus',
          url: "/order/create-order",
        },
        {
          id: "part.order",
          title: "Part Order",
          type: "item",
          // icon: 'heroicons-outline:plus',
          url: "/order/create-part-order",
        },
        {
          id: "project.order",
          title: " Bulk Project Order",
          type: "item",
          // icon: 'heroicons-outline:plus',
          url: "/order/special-project-order",
        },
        {
          id: "bulk.part.order",
          title: "Bulk Part Order",
          type: "item",
          url: "/order/bulk-part-order",
        },
        {
          id: "new.order",
          title: "New Orders",
          type: "item",
          // icon: 'heroicons-outline:desktop-computer',
          url: "/order/new-order-list",
        },
        {
          id: "order.management",
          title: "Order Management",
          type: "item",
          // icon: 'heroicons-outline:desktop-computer',
          url: "/order/order-list",
        },
        {
          id: "special.discount",
          title: "Special Discount",
          type: "item",
          // icon: 'heroicons-outline:tag',
          url: "/special-discount",
        },
        //   {
        //         id: "container.management",
        //         title: "Container Management",
        //         type: "item",
        //         // icon: 'heroicons-outline:truck',
        //         url: "/container-list",
        //     }
      ];

    }
    else if (token.scope.includes("ROLE_PARTNRORDPROCESS") || token.scope.includes("ROLE_PARTNER_ADMIN") || token.scope.includes("ROLE_SHWRMMGR")) {
      navigationConfig = [
        {
          id: "create.order",
          title: "Create Order",
          type: "item",
          // icon: 'heroicons-outline:plus',
          url: "/order/create-order",
        },
        {
          id: "part.order",
          title: "Part Order",
          type: "item",
          // icon: 'heroicons-outline:plus',
          url: "/order/create-part-order",
        },
        {
          id: "project.order",
          title: " Bulk Project Order",
          type: "item",
          // icon: 'heroicons-outline:plus',
          url: "/order/special-project-order",
        },
        {
          id: "bulk.part.order",
          title: "Bulk Part Order",
          type: "item",
          url: "/order/bulk-part-order",
        },
        {
          id: "order.management",
          title: "Order Management",
          type: "item",
          // icon: 'heroicons-outline:desktop-computer',
          url: "/order/order-list",
        },

        {
          id: "container.management",
          title: "Container Management",
          type: "item",
          // sicon: 'heroicons-outline:truck',
          url: "/container-list",
        },
      ];
    } else if (token.scope.includes("ROLE_LOGIMGR") || token.scope.includes("ROLE_LOGISTICS")) {
      navigationConfig = [

        {
          id: "container.management",
          title: "Container Management",
          type: "item",
          // sicon: 'heroicons-outline:truck',
          url: "/container-list",
        },
        {
          id: "order.management",
          title: "Order Management",
          type: "item",
          // icon: 'heroicons-outline:desktop-computer',
          url: "/order/order-list",
        },
      ];
    } else if (token.scope.includes("ROLE_IAM") && !(token.scope.includes("ROLE_ADMIN") || token.scope.includes("ROLE_MD") || token.scope.includes("ROLE_SOPDIR"))) {
      navigationConfig = [
        {
          id: "dashboard-group",
          title: "Dashboard",
          type: "collapse",
          icon: "heroicons-outline:desktop-computer",
          children: [
            {
              id: "dashboard-home",
              title: "Home",
              type: "item",
              url: "/dashboard",
            },
            {
              id: "sales-dashboard-home",
              title: "Sales Dashboard",
              type: "item",
              url: "/salesDashboard",
            },
          ],
        },
        {
          id: "sales",
          title: "Budget",
          type: "collapse",
          icon: "heroicons-outline:currency-euro",
          translate: "Budget",
          children: [
            {
              id: "sales-budget-component",
              title: "Sales Budget",
              // translate: 'OrderCategory',
              type: "item",
              // icon: 'heroicons-outline:currency-euro',
              url: "salesBudget",
            },
            {
              id: "marketing-budget-component",
              title: "Marketing Budget",
              type: "collapse",
              // icon: 'heroicons-outline:currency-rupee',
              url: "marketingBudget",
              children: [
                {
                  id: "apps.help-center.home",
                  title: "Budget Summary",
                  type: "item",
                  url: "marketingBudget/budget-summary",
                  end: true,
                },
              ],
            },
          ],
        },
        {
          id: "salesforecast",
          title: "Sales",
          type: "collapse",
          icon: "material-solid:insights",
          translate: "Sales",
          children: [
            {
              id: "retail-forecast-component",
              title: "Retail Forecast",
              type: "item",
              url: "retailForecast",
            },
            {
              id: "project-pipeline-component",
              title: "Project Pipeline",
              type: "item",
              url: "projectPipeline",
            },
            {
              id: "project-forecast-component",
              title: "Project Forecast",
              type: "item",
              url: "projectForecast",
            },
            {
              id: "sales-reports-group",
              title: "Reports",
              type: "collapse",
              children: [
                {
                  id: "sales-report-component",
                  title: "Sales Report",
                  type: "item",
                  url: "/sales/reports/forecastSalesReport",
                },
                {
                  id: "ytd-analysis-report-component",
                  title: "YTD Analysis Report",
                  type: "item",
                  url: "/sales/reports/ytdAnalysisReport",
                }
              ]
            }
          ],
        },
        {
          id: "customers-component",
          title: "Partners",
          translate: "Partners",
          type: "item",
          // icon: 'heroicons-outline:users',
          url: "partners",
        },
        {
          id: "showroom-component",
          title: "Showrooms",
          translate: "Showrooms",
          type: "item",
          url: "showrooms",
        },
        {
          id: "reports",
          title: "Reports",
          type: "collapse",
          // icon: "heroicons-outline:document",
          children: [
            {
              id: "report-dashboard",
              title: "Sales/Purchase Reports",
              type: "item",
              url: "/reports/reportDashboard"
            },
          ],
        },

        {
          id: "special.discount",
          title: "Special Discount",
          type: "item",
          url: "/special-discount",
        },
        {
          id: "order.management",
          title: "Order Management",
          type: "item",
          // icon: 'heroicons-outline:desktop-computer',
          url: "/order/order-list",
        },

        {
          id: "container.management",
          title: "Container Management",
          type: "item",
          // sicon: 'heroicons-outline:truck',
          url: "/container-list",
        },

      ];
    } else if (token.scope.includes("ROLE_ADMIN") || token.scope.includes("ROLE_MD") || token.scope.includes("ROLE_SOPDIR")) {
      navigationConfig = [
        {
          id: "dashboards",
          title: "Dashboards",
          // subtitle: 'Unique dashboard designs',
          type: "collapse",
          icon: 'material-twotone:speed',
          icon: "heroicons-outline:desktop-computer",
          translate: "Dashboards",
          children: [
            {
              id: "common-dashboard-component",
              title: "Home",
              translate: "Home",
              type: "item",
              // icon: 'heroicons-outline:desktop-computer',
              url: "dashboard",
            },
            {
              id: "sales-dashboard-component",
              title: "Sales Dashboard",
              type: "item",
              url: "salesDashboard",
            },
          ],
        },
        // {
        //   id: "human-resource",
        //   title: "Human Resource",
        //   type: "collapse",
        //   // translate: 'Human Resource',
        //   icon: "heroicons-outline:cube-transparent",
        //   children: [
        //     {
        //       id: "talent-profile",
        //       title: "Talent Profile",
        //       type: "collapse",
        //       // icon: 'heroicons-outline:presentation-chart-bar',
        //       // url: 'marketingBudget',
        //       children: [
        //         {
        //           id: "attendanceDashboard",
        //           title: "Attendance",
        //           type: "collapse",
        //           // icon: 'heroicons-outline:user-group',
        //           // url: 'attendanceManagement',
        //           children: [
        //             {
        //               id: "attendance-component",
        //               title: "Dashboard",
        //               type: "item",
        //               // icon: 'heroicons-outline:user-group',
        //               url: "attendance",
        //               end: true,
        //             },
        //             {
        //               id: "attendance-log",
        //               title: "Log",
        //               type: "item",
        //               url: "attendanceManagement/attendance-log",
        //               end: true,
        //             },
        //             {
        //               id: "attendance-management",
        //               title: "Management",
        //               type: "item",
        //               url: "attendanceManagement",
        //               end: true,
        //             },
        //           ],
        //         },
        //       ],
        //     },
        //     // {
        //     //   id: 'leave',
        //     //   title: 'Leave',
        //     //   type: 'collapse',
        //     //   // icon: 'heroicons-outline:currency-rupee',
        //     //   // url: 'leave',
        //     //   children: [
        //     //     {
        //     //       id: 'overview',
        //     //       title: 'Overview',
        //     //       type: 'item',
        //     //       // icon: 'heroicons-outline:currency-rupee',
        //     //       url: 'overview',
        //     //     },
        //     //     {
        //     //       id: 'management',
        //     //       title: 'Management',
        //     //       type: 'item',
        //     //       // icon: 'heroicons-outline:currency-rupee',
        //     //       url: 'management',
        //     //     },
        //     //     {
        //     //       id: 'alert',
        //     //       title: 'Alert',
        //     //       type: 'item',
        //     //       // icon: 'heroicons-outline:currency-rupee',
        //     //       url: 'alert',
        //     //     },
        //     {
        //       id: "asset-component",
        //       title: "Assets",
        //       type: "item",
        //       // icon: 'heroicons-outline:library',
        //       url: "assets",
        //     },
        //     {
        //       id: "asset-type-component",
        //       title: "Asset Types",
        //       type: "item",
        //       // icon: 'heroicons-outline:library',
        //       url: "assetTypes",
        //     },
        //     {
        //       id: "leave-management-component",
        //       title: "Leave Management",
        //       // translate: 'OrderCategory',
        //       type: "item",
        //       // icon: 'material-outline:exit_to_app',
        //       url: "leaveManagement",
        //     },
        //     {
        //       id: "calendar-component",
        //       title: "Holidays & Events",
        //       type: "item",
        //       // icon: 'heroicons-outline:calendar',
        //       url: "calendar",
        //     },
        //     //   ],
        //     // },
        //     {
        //       id: "training-education",
        //       title: "Training & Education",
        //       type: "item",
        //       // icon: 'heroicons-outline:currency-rupee',
        //       url: "training-education",
        //     },
        //     {
        //       id: "payroll",
        //       title: "Payroll",
        //       type: "item",
        //       // icon: 'heroicons-outline:currency-rupee',
        //       url: "payroll",
        //     },
        //     {
        //       id: "policies-forms",
        //       title: "Policies & Forms",
        //       type: "collapse",
        //       // icon: 'heroicons-outline:currency-rupee',
        //       // url: 'policies-forms',
        //       children: [
        //         {
        //           id: "hr-policies",
        //           title: "HR Policies",
        //           type: "item",
        //           // icon: 'heroicons-outline:document-text',
        //           url: "hrPolicies",
        //         },
        //       ],
        //     },
        //   ],
        // },
        {
          id: "addministration",
          title: "Administration",
          type: "collapse",
          icon: "heroicons-outline:presentation-chart-line",
          // translate: 'Administration',
          children: [
            {
              id: "user-component",
              title: "Users",
              translate: "Users",
              type: "item",
              // icon: 'heroicons-outline:users',
              url: "users",
            },
            {
              id: "roles-component",
              title: "Roles",
              translate: "Roles",
              type: "item",
              // icon: 'heroicons-outline:users',
              url: "roles",
            },
            {
              id: "employee-component",
              title: "Employees",
              type: "item",
              // icon: 'heroicons-outline:user-group',
              url: "employee",
            },
            {
              id: "okr-component",
              title: "OKR Performance Management",
              type: "item",
              // icon: 'material-outline:leaderboard',
              url: "okrPerformance",
            },
            // {
            //   id: 'attendance-management-component',
            //   title: 'Attendance Management',
            //   type: 'collapse',
            //   // icon: 'heroicons-outline:user-group',
            //   // url: 'attendanceManagement',
            //   children: [
            //     {
            //       id: 'attendance-management.dashboard',
            //       title: 'Dashboard',
            //       type: 'item',
            //       url: 'attendanceManagement',
            //       end: true,
            //     },
            //     {
            //       id: 'attendance-management.attendance-log',
            //       title: 'Attendance Log',
            //       type: 'item',
            //       url: 'attendanceManagement/attendance-log',
            //       end: true,
            //     },
            //   ],
            // },

            {
              id: "eurostat-comparison-component",
              title: "Eurostat Comparison",
              type: "item",
              // icon: 'heroicons-outline:currency-euro',
              url: "eurostatComparisons",
            },
            {
              id: "logistics-component",
              title: "Logistics",
              type: "collapse",
              // icon: 'heroicons-outline:cube-transparent',
              // url: 'logistics',
              children: [
                {
                  id: "logistics-component.dashboard",
                  title: "Dashboard",
                  type: "item",
                  url: "logistics",
                  end: true,
                },
                {
                  id: "logistics-component.settings",
                  title: "Settings",
                  type: "item",
                  url: "logistics/settings",
                  end: true,
                },
                {
                  id: "logistics-component.hscode",
                  title: "HS Code",
                  type: "item",
                  url: "logistics/hscode",
                  end: true,
                },
              ],
            },
            {
              id: "territories-component",
              title: "Territories",
              translate: "Territories",
              type: "item",
              // icon: 'heroicons-outline:globe-alt',
              url: "territories",
            },
            {
              id: "customers-component",
              title: "Partners",
              translate: "Partners",
              type: "item",
              // icon: 'heroicons-outline:users',
              url: "partners",
            },
            {
              id: "showroom-component",
              title: "Showrooms",
              translate: "Showrooms",
              type: "item",
              // icon: 'heroicons-outline:office-building',
              url: "showrooms",
            },
            {
              id: "ports-component",
              title: "Ports",
              translate: "Ports",
              type: "item",
              // icon: 'heroicons-outline:office-building',
              url: "/ports",
            },
            {
              id: "countries-component",
              title: "Countries",
              translate: "Countries",
              type: "item",
              // icon: 'heroicons-outline:globe',
              url: "countries",
            },
            {
              id: "cities-component",
              title: "Cities",
              translate: "Cities",
              type: "item",
              // icon: 'heroicons-outline:globe-alt',
              url: "cities",
            },
            {
              id: "constainer-type-component",
              title: "Container Type",
              // translate: 'Container Type',
              type: "item",
              // icon: 'heroicons-outline:server',
              url: "containerType",
            },
            {
              id: "pricegroup-component",
              title: "Price Groups",
              // translate: 'PriceGroups',
              type: "item",
              // icon: 'heroicons-outline:globe-alt',
              url: "pricegroups",
            },
            {
              id: "factory-vendor",
              title: "Factory Vendor",
              // translate: 'FactoryVendor',
              type: "item",
              // icon: 'heroicons-outline:home',
              url: "factoryVendors",
            },
            {
              id: "order-category-component",
              title: "Order Category",
              // translate: 'OrderCategory',
              type: "item",
              // icon: 'heroicons-outline:plus-circle',
              url: "orderCategory",
            },
            {
              id: "material-master-component",
              title: "Material Master",
              // translate: 'OrderCategory',
              type: "item",
              // icon: 'heroicons-outline:credit-card',
              url: "materialMasters",
            },
            {
              id: "shipping-type-component",
              title: "Shipping Type",
              // translate: 'ShippingType',
              type: "item",
              // icon: 'heroicons-outline:archive',
              url: "ShippingType",
            },
            // {
            //   id: "delivery-terms-component",
            //   title: "Delivery Terms",
            //   // translate: 'ShippingType',
            //   type: "item",
            //   // icon: 'heroicons-outline:archive',
            //   url: "deliveryTerms",
            // },
            {
              id: "region-component",
              title: "Regions",
              translate: "Regions",
              type: "item",
              // icon: 'heroicons-outline:globe-alt',
              url: "regions",
            },
             {
              id: "aoReason-component",
              title: "AO-Reasons",
              translate: "AO-Reasons",
              type: "item",
              // icon: 'heroicons-outline:office-building',
              url: "aoReason",
            },
            // {
            //   id: 'calendar-component',
            //   title: 'Holidays & Events',
            //   type: 'item',
            //   // icon: 'heroicons-outline:calendar',
            //   url: '/calendar',
            // },
          ],
        },
        {
          id: "sales",
          title: "Budget",
          type: "collapse",
          icon: "heroicons-outline:currency-euro",
          translate: "Budget",
          children: [
            {
              id: "sales-budget-component",
              title: "Sales Budget",
              // translate: 'OrderCategory',
              type: "item",
              // icon: 'heroicons-outline:currency-euro',
              url: "salesBudget",
            },
            {
              id: "marketing-budget-component",
              title: "Marketing Budget",
              type: "collapse",
              // icon: 'heroicons-outline:currency-rupee',
              url: "marketingBudget",
              children: [
                {
                  id: "apps.help-center.home",
                  title: "Budget Summary",
                  type: "item",
                  url: "marketingBudget/budget-summary",
                  end: true,
                },
              ],
            },
          ],
        },
        {
          id: "salesforecast",
          title: "Sales",
          type: "collapse",
          icon: "material-solid:insights",
          translate: "Sales",
          children: [
            {
              id: "retail-forecast-component",
              title: "Retail Forecast",
              type: "item",
              url: "retailForecast",
            }, {
              id: "discount-approval-component",
              title: "Discount Approvals",
              type: "item",
              url: "discountApproval",
            },
            {
              id: "project-pipeline-component",
              title: "Project Pipeline",
              type: "item",
              url: "projectPipeline",
            },
            {
              id: "project-forecast-component",
              title: "Project Forecast",
              type: "item",
              url: "projectForecast",
            },
            {
              id: "sales-reports-group",
              title: "Reports",
              type: "collapse",
              children: [
                {
                  id: "sales-report-component",
                  title: "Sales Report",
                  type: "item",
                  url: "/sales/reports/forecastSalesReport",
                },
                {
                  id: "ytd-analysis-report-component",
                  title: "YTD Analysis Report",
                  type: "item",
                  url: "/sales/reports/ytdAnalysisReport",
                }
              ]
            }
          ],
        },

        {
          id: "discount",
          title: "Discount",
          type: "collapse",
          icon: "feather:percent",
          translate: "Discount",
          children: [
            {
              id: "discount-master-component",
              title: "Discount Master",
              // translate: 'OrderCategory',
              type: "item",
              // icon: 'feather:percent',
              url: "discountMaster",
            },
            {
              id: "transfer-discount-component",
              title: "Transfer Discount",
              // translate: 'OrderCategory',
              type: "item",
              // icon: 'feather:percent',
              url: "transferDiscount",
            },
            {
              id: "german-vat-component",
              title: "German VAT",
              // translate: 'OrderCategory',
              type: "item",
              // icon: 'feather:percent',
              url: "germanVat",
            },
            {
              id: "price-increase",
              title: "Price Increase",
              // translate: 'OrderCategory',
              type: "item",
              // icon: 'feather:percent',
              url: "priceIncrease",
            },
            {
              id: "customer-price-increase",
              title: "Customer Price Increase",
              // translate: 'OrderCategory',
              type: "item",
              // icon: 'feather:percent',
              url: "customerPriceIncrease",
            },
            {
              id: "vendor-price-increase",
              title: "Vendor Price Increase",
              // translate: 'OrderCategory',
              type: "item",
              // icon: 'feather:percent',
              url: "vendorPriceIncrease",
            },
          ],
        },

        // {
        //   id: 'hr',
        //   title: 'HR',
        //   type: 'collapse',
        //   // icon: 'material:person',
        //   translate: 'HR',
        //   children: [
        //     {
        //       id: 'leave-management-component',
        //       title: 'Leave Management',
        //       // translate: 'OrderCategory',
        //       type: 'item',
        //       icon: 'material-outline:exit_to_app',
        //       url: 'leaveManagement',
        //     }
        //   ]
        // },
        // {
        //   id: "finance",
        //   title: "Finance",
        //   type: "collapse",
        //   icon: "heroicons-outline:receipt-tax",
        //   translate: "Finance",
        //   children: [
        //     {
        //       id: "chart-of-account-component",
        //       title: "Chart of Accounts",
        //       type: "item",
        //       // icon: 'heroicons-outline:calculator',
        //       url: "chart-of-accounts",
        //     },
        //     {
        //       id: "statement-of-account-component",
        //       title: "Statement of Accounts",
        //       type: "item",
        //       // icon: 'heroicons-outline:document-text',
        //       url: "statement-of-account",
        //     },
        //     {
        //       id: "payroll",
        //       title: "Payroll",
        //       type: "item",
        //       // icon: 'heroicons-outline:currency-rupee',
        //       url: "payroll",
        //     },
        //     {
        //       id: "payroll-salary",
        //       title: "Salaries",
        //       type: "collapse",
        //       // // icon: 'heroicons-outline:currency-rupee',
        //       url: "salaries",
        //       children: [
        //         {
        //           id: "payroll-salary-revision",
        //           title: "Salary Revision",
        //           type: "item",
        //           url: "salary/revision",
        //         },
        //       ],
        //     },
        //     {
        //       id: "payroll-loan",
        //       title: "Loan",
        //       type: "collapse",
        //       // // icon: 'heroicons-outline:currency-rupee',
        //       url: "loans",
        //       children: [
        //         {
        //           id: "payroll-loans-deduction",
        //           title: "Loan Deduction",
        //           type: "item",
        //           url: "loan/deduction",
        //         },
        //       ],
        //     },
        //     {
        //       id: "payroll-bonus",
        //       title: "Bonus",
        //       type: "item",
        //       // // icon: 'heroicons-outline:currency-rupee',

        //       url: "bonus",
        //     },
        //     {
        //       id: "payroll-cpa",
        //       title: "Employee Cost",
        //       type: "item",
        //       // // icon: 'heroicons-outline:currency-rupee',
        //       url: "cpa",
        //     },
        //     {
        //       id: "payroll-gratuity",
        //       title: "Gratuity",
        //       type: "item",
        //       // // icon: 'heroicons-outline:calculator',
        //       url: "gratuity",
        //     },
        //     {
        //       id: "exit-process",
        //       title: "Exit Process",
        //       type: "item",
        //       // // icon: 'heroicons-outline:calculator',
        //       url: "exit-process",
        //     },
        //     {
        //       id: "expense-claim",
        //       title: "Expense Claim",
        //       type: "item",
        //       // // icon: 'heroicons-outline:calculator',
        //       url: "expense-claim",
        //     },
        //     {
        //       id: "financial-year-component",
        //       title: "Financial Year",
        //       type: "item",
        //       // icon: 'heroicons-outline:calendar',
        //       url: "financial-year",
        //     },
        //     {
        //       id: "payment-terms-component",
        //       title: "Payment Terms",
        //       type: "item",
        //       // icon: 'heroicons-outline:cash',
        //       url: "payment-terms",
        //     },
        //     {
        //       id: "trial-balance-component",
        //       title: "Trial Balance",
        //       type: "item",
        //       // icon: 'heroicons-outline:document-text',
        //       url: "trial-balance",
        //     },
        //     {
        //       id: 'nominal-ledger-component',
        //       title: 'Nominal Ledger',
        //       type: 'item',
        //       // icon: 'heroicons-outline:document-text',
        //       url: 'nominal-ledger',
        //     },
        //     {
        //       id: "daily-exchange-rate-component",
        //       title: "Daily Exchange Rates",
        //       type: "item",
        //       // icon: 'material-outline:swap_horiz',
        //       url: "dailyExchangeRates",
        //     },
        //     {
        //       id: "voucher-component",
        //       title: "Voucher",
        //       type: "item",
        //       // icon: 'heroicons-outline:gift',
        //       url: "voucher",
        //     },
        //     {
        //       id: "voucherType-component",
        //       title: "Voucher Type",
        //       type: "item",
        //       // icon: 'heroicons-outline:gift',
        //       url: "voucherTypes",
        //     },
        //     {
        //       id: "reconciliation-component",
        //       title: "Reconciliation",
        //       type: "item",
        //       // icon: 'material-solid:supervised_user_circle',
        //       url: "reconciliation",
        //     },
        //     {
        //       id: "proformainvoice-component",
        //       title: "Proforma Invoice",
        //       type: "item",
        //       // icon: 'material-outline:receipt',
        //       url: "proformaInvoice",
        //     },
        //     {
        //       id: "financeinvoice-component",
        //       title: "Finance Invoice",
        //       type: "item",
        //       // icon: 'material-outline:receipt',
        //       url: "financeinvoice",
        //     },
        //     // {
        //     //   id: 'salesinvoice-component',
        //     //   title: 'Sales Invoice',
        //     //   type: 'item',
        //     //   icon: 'material-outline:receipt',
        //     //   url: 'salesinvoice',
        //     // },
        //     // {
        //     //   id: 'purchaseInvoice-component',
        //     //   title: 'Purchase Invoice',
        //     //   type: 'item',
        //     //   icon: 'material-outline:receipt',
        //     //   url: 'purchaseInvoice',
        //     // },
        //     {
        //       id: "letterOfCredit-component",
        //       title: "Letter Of Credit",
        //       type: "item",
        //       // icon: 'material-outline:text_snippet',
        //       url: "letterOfCredit",
        //     },
        //     {
        //       id: "bank-component",
        //       title: "Bank",
        //       type: "item",
        //       // icon: 'material-outline:account_balance',
        //       url: "bank",
        //     },
        //     {
        //       id: "usance-component",
        //       title: "Usance",
        //       type: "item",
        //       // icon: 'material-outline:date_range',
        //       url: "usance",
        //     },
        //   ],
        // },
        {
          id: "design-studio",
          title: "Design Studio",
          type: "collapse",
          icon: "material-outline:auto_fix_high",
          children: [
            {
              id: "dashboard",
              title: "Dashboard",
              type: "item",
              // icon: 'heroicons-outline:desktop-computer',
              url: "/design-studio/dashboard",
            },
            {
              id: "designstudio.request",
              title: "New Design Request",
              type: "item",
              // icon: 'heroicons-outline:plus',
              url: "/design-studio/new-request",
            },
            {
              id: "request-list",
              title: "Request Lists",
              type: "item",
              // icon: 'heroicons-outline:clipboard-list',
              url: "/design-studio/request-list",
            },
            {
              id: "display-master",
              title: "Display Master",
              type: "item",
              // icon: 'heroicons-outline:color-swatch',
              url: "/design-studio/display-master",
              // auth: authRoles.designerHead,
            },
          ],
        },
        {
          id: 'training',
          title: 'Training',
          icon: 'heroicons-outline:desktop-computer',
          type: 'collapse',
          children: [
            {
              id: 'dashboard',
              title: 'Dashboard',
              type: 'item',
              url: '/trainingDashboard',
            },
            {
              id: 'trainers-list',
              title: "Trainers List",
              type: 'item',
              url: '/trainersList',
            },
            {
              id: 'training-course-list',
              title: "Training Course List",
              type: 'item',
              url: '/trainingCourseList',
            }
          ]
        },
        {
          id: "reports",
          title: "Reports",
          type: "collapse",
          icon: "heroicons-outline:document",
          children: [
            {
              id: "ao-analysis",
              title: "AO Analysis ",
              type: "item",
              url: "/reports/ao-analysis",
            },
            {
              id: "report-dashboard",
              title: "Sales/Purchase Reports",
              type: "item",
              url: "/reports/reportDashboard"
            },
            {
              id: "factory-issues",
              title: "Factory Issues ",
              type: "item",
              url: "/reports/factory-issues",
            },
            
          ],
        },
        {
          id: "order",
          title: "Technical Division",
          type: "collapse",
          icon: "heroicons-outline:cube",
          children: [
            {
              id: "order.dashboard",
              title: "Dashboard",
              type: "item",
              // icon: 'heroicons-outline:desktop-computer',
              url: "/order/dashboard",
            },
            {
              id: "create.order",
              title: "Create Order",
              type: "item",
              // icon: 'heroicons-outline:plus',
              url: "/order/create-order",
            },
            {
              id: "part.order",
              title: "Part Order",
              type: "item",
              // icon: 'heroicons-outline:plus',
              url: "/order/create-part-order",
            },
            {
              id: "project.order",
              title: " Bulk Project Order",
              type: "item",
              // icon: 'heroicons-outline:plus',
              url: "/order/special-project-order",
            },
            {
              id: "bulk.part.order",
              title: "Bulk Part Order",
              type: "item",
              url: "/order/bulk-part-order",
            },
            {
              id: "new.order",
              title: "New Order",
              type: "item",
              // icon: 'heroicons-outline:desktop-computer',
              url: "/order/new-order-list",
            },
            {
              id: "order.management",
              title: "Order Management",
              type: "item",
              // icon: 'heroicons-outline:desktop-computer',
              url: "/order/order-list",
            },
            {
              id: "container.management",
              title: "Container Management",
              type: "item",
              // icon: 'heroicons-outline:truck',
              url: "/container-list",
            },
            {
              id: "special.discount",
              title: "Special Discount",
              type: "item",
              // icon: 'heroicons-outline:tag',
              url: "/special-discount",
            },
            {
              id: "abs.without.order",
              title: "ABs without Order",
              type: "item",
              // icon: 'heroicons-outline:tag',
              url: "/order/abs-without-order",
            },

          ],
        },
      ];
    }
  }

  return navigationConfig;
};

export default getNavigation;
